var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"absolute","top":"45px","right":"15px","z-index":"999"}},[(_vm.alerta.mensagem)?_c('v-alert',{style:(`color: ${_vm.fontColor}`),attrs:{"dense":"","type":_vm.alerta.tipo,"dismissible":"","close-icon":"mdi-close","color":_vm.color,"light":""}},[_vm._v(" "+_vm._s(_vm.alerta.mensagem)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }